/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Cell input type
 */
export type CustomColumnDefinitionDtoMetadataType = typeof CustomColumnDefinitionDtoMetadataType[keyof typeof CustomColumnDefinitionDtoMetadataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomColumnDefinitionDtoMetadataType = {
  String: 'String',
  Number: 'Number',
  Date: 'Date',
  DateTime: 'DateTime',
  CheckBox: 'CheckBox',
  SelectOne: 'SelectOne',
} as const;
